import Vue from 'vue'
import VueRouter from 'vue-router'
import Avaliar from '../views/Avaliar.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:name/:phone',
    name: 'Avaliar',
    component: Avaliar,
    props: {
      name: String,
      phone: String
    }
  },
  {
    path: '/:name',
    name: 'Avaliar',
    component: Avaliar,
    props: {
      name: String,
      phone: String
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
